import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import './MemoryPreview.css';

// 실제 생성하신 워커 주소가 있다면 여기에 넣어주세요.
const INSTAGRAM_WORKER_URL = 'https://instagram-proxy.calicorone.workers.dev';

export default function MemoryPreview() {
  const [memories, setMemories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMemories = async () => {
      setLoading(true);
      try {
        // 1. 먼저 인스타그램 워커 호출 시도
        const response = await fetch(INSTAGRAM_WORKER_URL).catch(() => null);
        
        if (response && response.ok) {
          const data = await response.json();
          const posts = Array.isArray(data) ? data : (data.data || []);
          
          if (posts.length > 0) {
            setMemories(posts.slice(0, 6).map(post => ({
              id: post.id,
              image_url: post.media_url || post.image || post.thumbnail_url,
              link: post.permalink || post.link,
              created_at: post.timestamp || post.pubDate,
              caption: post.caption || post.title
            })));
            setLoading(false);
            return;
          }
        }

        // 2. 인스타그램 데이터가 없으면 Supabase(관리자 업로드) 데이터 가져오기
        const { data: dbData, error } = await supabase
          .from('memories')
          .select('*')
          .order('created_at', { ascending: false })
          .limit(6);

        if (!error && dbData) {
          setMemories(dbData);
        }
      } catch (err) {
        console.error('Fetch error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchMemories();
  }, []);

  if (loading) {
    return (
      <div className="memory-preview-container">
        <div className="memory-loading">불러오는 중...</div>
      </div>
    );
  }

  return (
    <div className="memory-preview-container">
      {memories.length > 0 ? (
        <>
          <div
            className="memory-grid"
            style={{
              gridTemplateColumns:
                memories.length === 4 || memories.length === 2
                  ? 'repeat(2, 1fr)'
                  : 'repeat(3, 1fr)',
            }}
          >
            {memories.map((m, i) => (
              <a 
                href={m.link || '#'} 
                key={m.id || i} 
                className="memory-item"
                target={m.link ? "_blank" : "_self"}
                rel="noopener noreferrer"
              >
                <div className="image-wrapper">
                  <img src={m.image_url} alt={m.caption || 'Memory'} />
                  <div className="overlay">
                    <span className="date">
                      {m.created_at ? new Date(m.created_at).toLocaleDateString() : 'Recent'}
                    </span>
                  </div>
                </div>
              </a>
            ))}
          </div>
          <div className="view-more-wrapper">
            <a 
              href="https://www.instagram.com/calicorone/" 
              className="view-more-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              Follow on Instagram →
            </a>
          </div>
        </>
      ) : (
        <div className="no-memories">
          <p>아직 등록된 사진이 없습니다.</p>
          <Link to="/memories" className="upload-link">사진 등록하러 가기</Link>
        </div>
      )}
    </div>
  );
}
